import { createApp } from 'vue'
import App from './App.vue'
import './assets/GlobalCss.css'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'

const firebaseConfig = {
    apiKey: "AIzaSyDNlrEolbhd-jsUbXVT87uqJ8U3GO_4hm8",
    authDomain: "tania-s-sweet-treats.firebaseapp.com",
    databaseURL: "https://tania-s-sweet-treats-default-rtdb.firebaseio.com",
    projectId: "tania-s-sweet-treats",
    storageBucket: "tania-s-sweet-treats.appspot.com",
    messagingSenderId: "1095938567562",
    appId: "1:1095938567562:web:102a12bb9a73012e78ec73",
    measurementId: "G-G146TW60EV"
}

export default firebase.initializeApp(firebaseConfig)

createApp(App).mount('#app')